/**
 * Gera as variações plausíveis de um número de telefone brasileiro para BUSCA
 * tolerante ao "nono dígito".
 *
 * Contexto: o vCard do WhatsApp às vezes traz o waid SEM o nono dígito
 * (ex: 559982192898), enquanto o contato no banco está salvo COM o nono dígito
 * (ex: 5599982192898). A busca exata falha; gerando as duas formas, achamos o
 * contato existente em vez de oferecer "Adicionar" (e duplicar).
 *
 * Estrutura BR celular: 55 (DDI) + DD (DDD, 2) + número (8 sem o 9, ou 9 com o 9).
 * Para números não-BR ou que não encaixam, retorna só o próprio número.
 *
 * Retorna um array de strings (dígitos), começando pelo número original.
 */
export function phoneVariations(input) {
  const digits = String(input || "").replace(/\D/g, "");
  if (!digits) return [];

  const out = new Set([digits]);

  // Só mexe em número BR (DDI 55) com DDD de 2 dígitos.
  if (digits.startsWith("55")) {
    const rest = digits.slice(2);       // DD + número
    const ddd = rest.slice(0, 2);
    const local = rest.slice(2);

    if (ddd.length === 2) {
      if (local.length === 8) {
        // sem o 9 → adiciona a versão COM o 9
        out.add(`55${ddd}9${local}`);
      } else if (local.length === 9 && local.startsWith("9")) {
        // com o 9 → adiciona a versão SEM o 9
        out.add(`55${ddd}${local.slice(1)}`);
      }
    }
  }

  return [...out];
}
